import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faStackOverflow
} from '@fortawesome/free-brands-svg-icons';

import {
  faTerminal,
  faCode
} from '@fortawesome/free-solid-svg-icons';

import Particles from 'react-particles-js';

export default class Header extends Component {
  render() {
    return (
      <React.Fragment>
    {/* Header
    ================================================== */}
      <header id="home">
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
          <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
          <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
            <li><a className="smoothscroll" href="#resume">Resume</a></li>
            <li><a className="smoothscroll" href="#portfolio">Projects</a></li>
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
          </ul> {/* end #nav */}
        </nav> {/* end #nav-wrap */}
        <div className="row banner">
          <div className="banner-text">
            <h1 className="responsive-headline">Hi, I'm Wilson Ler</h1>
            <h3>Computers can <span>see</span> with <span>AI</span> and <span>Computer Vision</span>.
            </h3>
            <hr />
            <ul className="social">
              <li><a href="https://www.linkedin.com/in/wilson-ler-664b51110"> <FontAwesomeIcon icon={faLinkedin} /></a></li>
              <li><a href="https://open.kattis.com/users/wilson-ler"><FontAwesomeIcon icon={faTerminal} /></a></li>
              <li><a href="https://github.com/lws803"><FontAwesomeIcon icon={faGithub} /></a></li>
              <li><a href="https://stackoverflow.com/users/7041177/lws803"><FontAwesomeIcon icon={faStackOverflow} /></a></li>
              <li><a href="https://sourcerer.io/lws803"><FontAwesomeIcon icon={faCode} /></a></li>

            </ul>
          </div>
        </div>
        <p className="scrolldown">
          <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
        </p>
      </header> {/* Header End */}

      </React.Fragment>
    );
  }
}
